module.exports = __webpack_public_path__ + "static/media/SWTH-BNB.9b5f8630.svg";